import { environment as EnvDev } from './environment.develop';
import { environment as EnvTest } from './environment.test';
import { environment as EnvRc } from './environment.rc';
import { environment as EnvProd } from './environment.prod';

export const SentryVariables = {
  getCurrentEnvironment: () => {
    const hostName = window.location.hostname;
    switch (hostName) {
      case 'business-dev.bcc.kz': {
        return EnvDev.currentEnvironment;
      }
      case 'business-test.bcc.kz': {
        return EnvTest.currentEnvironment;
      }
      case 'business-rc.bcc.kz': {
        return EnvRc.currentEnvironment;
      }
      case 'business.bcc.kz': {
        return EnvProd.currentEnvironment;
      }
      default: {
        return 'unknown';
      }
    }
  },
  getEnv: () => {
    const hostName = window.location.hostname;
    switch (hostName) {
      case 'business-dev.bcc.kz': {
        return EnvDev;
      }
      case 'localhost': {
        return EnvTest;
      }
      case 'business-test.bcc.kz': {
        return EnvTest;
      }
      case 'business-rc.bcc.kz': {
        return EnvRc;
      }
      case 'business.bcc.kz': {
        return EnvProd;
      }
      default: {
        return EnvTest;
      }
    }
  },
  getSentryDSN: () => {
    const hostName = window.location.hostname;
    switch (hostName) {
      case 'business-dev.bcc.kz': {
        return EnvDev.SENTRY_DSN;
      }
      case 'business-test.bcc.kz': {
        return EnvTest.SENTRY_DSN;
      }
      case 'business-rc.bcc.kz': {
        return EnvRc.SENTRY_DSN;
      }
      case 'business.bcc.kz': {
        return EnvProd.SENTRY_DSN;
      }
      default: {
        return '';
      }
    }
  },
};
